import React from 'react';
import { Table } from 'semantic-ui-react';
import { useMeasure } from 'react-use';
import DictionaryFieldButtonGroup from '../containers/DictionaryFieldButtonGroup';
import DictionaryFieldTools from '../containers/DictionaryFieldTools';

const DictionaryFieldActionsCell = ({
  code,
  category,
  dictionaryUUID,
  fieldUUID,
  template,
  upward,
}) => {
  const [ref, { width }] = useMeasure();

  return (
    <Table.Cell singleLine textAlign="right">
      <div ref={ref}>
        {(width > 70) && (
        <DictionaryFieldButtonGroup
          code={code}
          category={category}
          dictionaryUUID={dictionaryUUID}
          fieldUUID={fieldUUID}
        />
        )}
        {(width <= 70) && (
        <DictionaryFieldTools
          code={code}
          category={category}
          dictionaryUUID={dictionaryUUID}
          fieldUUID={fieldUUID}
          upward={upward}
          template={template}
        />
        )}
      </div>
    </Table.Cell>
  );
};

export default DictionaryFieldActionsCell;
